import {
	type StarterDashboardV2PageData,
	useStarterDashboardV2PageData,
} from 'src/app/pages/starterDashboardV2/pageContext';
// FIXME refactor needed to not import internal logic from the shared hooks
// eslint-disable-next-line @change/sibling-module-imports
import { useShareVisualModalBody } from 'src/app/pages/starterDashboardV2/shared/hooks/useTriggerShareVisualModal/useShareVisualModal/components/ShareVisualModalBody/hooks/useShareVisualModalBody';

import { useShareSocial } from '../../../ShareYourPetition/components/ShareSocial/hooks/useShareSocial';

type Context = 'starter_dashboard_grow_petition';
type UseShareVisualReturn = ModelHookResult<
	{
		buttonDisabled: boolean;
		shareVisualDownloaded: boolean;
		shareVisualEnabled: boolean;
		shareVisualsState: 'loading' | 'loaded' | 'timeout';
		petition: StarterDashboardV2PageData['petition'];
	},
	{
		onShareVisualDownload: (event: React.FormEvent<HTMLFormElement>) => void;
		onShareVisualSelect: () => void;
	}
>;

export function useShareVisual(): UseShareVisualReturn {
	const {
		data: { petition },
	} = useStarterDashboardV2PageData();
	const {
		data: { shareVisual },
	} = useShareSocial();
	const context: Context = 'starter_dashboard_grow_petition';
	const {
		data,
		actions: { onShareVisualDownload, onShareVisualSelect },
	} = useShareVisualModalBody({ petition, context });

	return {
		data: {
			petition,
			buttonDisabled: data.disabled,
			shareVisualDownloaded: data.shareVisualDownloaded,
			shareVisualEnabled: shareVisual.enabled,
			shareVisualsState: data.shareVisualsState,
		},
		actions: {
			onShareVisualDownload,
			onShareVisualSelect,
		},
	};
}
